import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null);
  const [initialized, setInitialized] = useState(false);

  const logout = useCallback(() => {
    localStorage.removeItem('token');
    localStorage.removeItem('user_id');
    setUser(null);
  }, []);

  const fetchProfile = useCallback(async (token) => {
    try {
      const response = await fetch(
        'https://api.nusa-sarat.nuncorp.id/api/v1/auth/profile',
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 401) {
        logout();
        return;
      }

      if (response.ok) {
        const data = await response.json();
        setUser(data.body);
      }
    } catch (err) {
      console.error('Fetch profile failed', err);
    }
  }, [logout]);

  // 🔥 INITIAL AUTH CHECK — JALAN SEKALI
  useEffect(() => {
    const token = localStorage.getItem('token');

    const initAuth = async () => {
      if (token) {
        await fetchProfile(token);
      }
      setLoading(false);
      setInitialized(true);
    };

    initAuth();
  }, [fetchProfile]);

  const login = async ({ username, password }) => {
    setError(null);

    const response = await fetch(
      'https://api.nusa-sarat.nuncorp.id/api/v1/auth/login',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      }
    );

    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.message || 'Login failed');
    }

    const result = await response.json();
    localStorage.setItem('token', result.body.token);
    localStorage.setItem('user_id', result.body.user_id);

    await fetchProfile(result.body.token);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        initialized,
        error,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
